import formatRoutes from '@/helpers/user-redesign/formatRoutes';

export const withoutNavigationRoutes = [
  {
    path: '/redesign/home',
    name: 'redesign-home',
    component: () => import('@/modules/UserEvents/views/certificate-home.vue'),
    meta: {
      title: 'Мои мероприятия',
    },
  },
];

export default [
  ...formatRoutes(withoutNavigationRoutes, { breadcrumbs: false, backControl: false, layout: 'ui-design' }),
];
